import React from 'react';
import TopRightArrowIcon from '../../../../assets/Svg/TopRightArrowIcon';
import Button from '../../../../common/_custom/Button/Button';
import styles from './GstOverview.module.scss';
import { GST_CONSENT_LOG_LABEL } from './constants';

interface GstConsentLogLinkProps {
    disabled?: boolean;
    onOpen: () => void;
}

/** Entry point for the org-wide GST consent panel; the host owns the drawer so a bar re-fit can't unmount it. */
function GstConsentLogLink({ disabled = false, onOpen }: Readonly<GstConsentLogLinkProps>) {
    return (
        <Button
            type="button"
            text={GST_CONSENT_LOG_LABEL}
            className={styles.GstConsentLogLink}
            icon={<TopRightArrowIcon width="14" height="14" />}
            disabled={disabled}
            onClick={() => {
                if (disabled) return;
                onOpen();
            }}
        />
    );
}

export default GstConsentLogLink;
